// extracted by mini-css-extract-plugin
export default {"outerDiv":"courses-page_outerDiv__GiV54","vInfoDiv":"courses-page_vInfoDiv__15uwe","editBtn":"courses-page_editBtn__Sc+l1","addBtn":"courses-page_addBtn__cz3In"};